const void_tag_names = [
    'AREA',
    'BASE',
    'BASEFONT',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'FRAME',
    'HR',
    'IMG',
    'INPUT',
    'ISINDEX',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR',

    // common self closing svg elements
    'PATH',
    'CIRCLE',
    'ELLIPSE',
    'LINE',
    'RECT',
    'USE',
    'STOP',
    'POLYLINE',
    'POLYGON',
]

const void_tag_index = {}

void_tag_names.forEach(tag => { void_tag_index[tag] = true })


module.exports = {
    list: void_tag_names,
    index: void_tag_index,
}
